<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span style="background-color: red"></span> Atrasado
      <span
        v-b-tooltip.hover
        title="Gestantes com atendimento de pré-natal em atraso conforme protocolo."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span style="background-color: green"></span> Em dias
      <span
        v-b-tooltip.hover
        title="Gestantes com consultas pré-natal em dias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: () => {},
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$emit('resetarNome', this.setRed)
          this.greens = false
          this.reds = true
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style>
.subtitle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.subtitle-item {
  font-size: 13px;
  margin: 25px 10px;
}
.subtitle-item span {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
}

.subtitle-item span i {
  font-size: 14px;
  vertical-align: top;
}

/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}
</style>
